import { render } from "./PlotLegendItemCollapsed.vue?vue&type=template&id=db405e18"
import script from "./PlotLegendItemCollapsed.vue?vue&type=script&lang=js"
export * from "./PlotLegendItemCollapsed.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__